module.exports = __webpack_public_path__ + "img/mexico866.d0305f0d.jpg";